import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	filters: {
		judge: {},
		court: {},
		date: ''
	},
	shouldReloadData: false,
	shouldResetFilters: false
};

const courtCalendarViewAllSlice = createSlice({
	initialState,
	name: 'courtCalendarViewAllSlice',
	reducers: {
		setFilters: (state, action) => {
			state.filters = { ...state.filters, ...action.payload };
		},
		setShouldReloadData: (state, action) => {
			state.shouldReloadData = action.payload;
		},
		setshouldResetFilters: (state, action) => {
			state.shouldResetFilters = action.payload;
		}
	}
});

export const { setFilters, setShouldReloadData, setshouldResetFilters } =
	courtCalendarViewAllSlice.actions;

export default courtCalendarViewAllSlice.reducer;
